import type {Dispatch, GetState, ThunkAction} from 'src/reducers';
import type {ApiOptions, ApiPostOptions} from 'src/utils/redux-api';

import {thunkify as flow} from 'src/utils/thunks';
import * as reduxApi from 'src/utils/redux-api';

import {key, fetching} from 'src/utils/redux';
import type {
  EMAIL_AUTOMATION_TEMPLATE,
  CANDIDATE_JOB_MASKING,
} from 'src/types/crm';


const API_PATH: ApiOptions = {
  apiPath: '/trmapi',
};
const POST_API_OPTIONS: ApiPostOptions = {
  apiPath: '/trmapi',
};
export const GET_AUTOMATION_TEMPLATES = 'get-automation-templates';
export const UPDATE_AUTOMATION_STATUS = 'update-automation-status';
export const GET_JOB_MASKING = 'get-job-masking';
export const UPDATE_JOB_MASKING = 'update-job-masking';

export type CrmEmailAutomationActions =
  | GetAutomationTemplatesAction
  | UpdateAutomationStatusAction;

export type GetAutomationTemplatesAction = {
  type: typeof GET_AUTOMATION_TEMPLATES;
  payload: EMAIL_AUTOMATION_TEMPLATE[];
};

export type UpdateAutomationStatusAction = {
  type: typeof UPDATE_AUTOMATION_STATUS;
  payload: EMAIL_AUTOMATION_TEMPLATE;
};

export type GetJobMaskingAction = {
  type: typeof GET_JOB_MASKING;
  payload: CANDIDATE_JOB_MASKING;
};

export type UpdateJobMaskingAction = {
  type: typeof UPDATE_JOB_MASKING;
  payload: CANDIDATE_JOB_MASKING;
};

export const setEmailAutomationTemplates = (
  payload: EMAIL_AUTOMATION_TEMPLATE[],
): GetAutomationTemplatesAction => ({
  type: GET_AUTOMATION_TEMPLATES,
  payload,
});

export const updateAutomationStatus = (
  pyaload: EMAIL_AUTOMATION_TEMPLATE,
): UpdateAutomationStatusAction => ({
  type: UPDATE_AUTOMATION_STATUS,
  payload: pyaload,
});

export const setJobMasking = (
  payload: CANDIDATE_JOB_MASKING,
): GetJobMaskingAction => ({
  type: GET_JOB_MASKING,
  payload,
});

export const updateJobMasking = (
  payload: CANDIDATE_JOB_MASKING,
): UpdateJobMaskingAction => ({
  type: UPDATE_JOB_MASKING,
  payload,
});

export const getEmailAutomationTemplates: (jobId: number) => ThunkAction<void> =
  flow(
    key((jobId) => `crm/email-automation-templates/${jobId}`),
    fetching(),
  )((jobId) => (dispatch: Dispatch) => {
    return dispatch(
      reduxApi.get(`/api/job-email-configuration/${jobId}`, {}, API_PATH),
    ).then(
      // @ts-expect-error - TS2345 - Argument of type '(response: EMAIL_AUTOMATION_TEMPLATE[]) => any' is not assignable to parameter of type '(value: unknown) => any'.
      (response: EMAIL_AUTOMATION_TEMPLATE[]) => {
        // @ts-expect-error - TS2769 - No overload matches this call.
        return dispatch(setEmailAutomationTemplates(response));
      },
      (error) => {
        // Error handling
      },
    );
  });

type UpdateEmailAutomationStatus = {
  jobEmailConfigurationId: number;
  status: boolean;
  jobId: number;
};

export const updateEmailAutomationStatus: (
  payload: UpdateEmailAutomationStatus,
) => ThunkAction<void> = flow(
  key(
    ({jobEmailConfigurationId}) =>
      `crm/email-automation-template-status/${jobEmailConfigurationId}`,
  ),
  fetching(),
)((payload) => (dispatch: Dispatch) => {
  const {jobEmailConfigurationId, status, jobId} = payload;
  return dispatch(
    reduxApi.post(
      `/api/job-email-configuration/${jobId}`,
      {
        jobEmailConfigurationId,
        status,
      },
      {},
      POST_API_OPTIONS,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: EMAIL_AUTOMATION_TEMPLATE) => any' is not assignable to parameter of type '(value: unknown) => any'.
    (response: EMAIL_AUTOMATION_TEMPLATE) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return dispatch(updateAutomationStatus(response));
    },
    (error) => {
      // Error handling
    },
  );
});

export const getCandidateJobMasking: (jobId: number) => ThunkAction<void> =
  flow(
    key((jobId) => `crm/job-masking-enabled/${jobId}`),
    fetching(),
  )((jobId) => (dispatch: Dispatch) => {
    return dispatch(
      reduxApi.get(`/api/masking-enabled-jobs/${jobId}`, {}, API_PATH),
    ).then(
      // @ts-expect-error - TS2345 - Argument of type '(response: CANDIDATE_JOB_MASKING) => any' is not assignable to parameter of type '(value: unknown) => any'.
      (response: CANDIDATE_JOB_MASKING) => {
        // @ts-expect-error - TS2769 - No overload matches this call.
        return dispatch(setJobMasking(response));
      },
      (error) => {
        // Error handling
      },
    );
  });

export const updateCandidateJobMasking: (jobId: number) => ThunkAction<void> =
  flow(
    key((jobId) => `crm/job-masking-toggle/${jobId}`),
    fetching(),
  )((jobId) => (dispatch: Dispatch) => {
    return dispatch(
      reduxApi.post(
        `/api/masking-enabled-jobs/${jobId}`,
        {},
        {},
        POST_API_OPTIONS,
      ),
    ).then(
      // @ts-expect-error - TS2345 - Argument of type '(response: CANDIDATE_JOB_MASKING) => any' is not assignable to parameter of type '(value: unknown) => any'.
      (response: CANDIDATE_JOB_MASKING) => {
        // @ts-expect-error - TS2769 - No overload matches this call.
        return dispatch(updateJobMasking(response));
      },
      (error) => {
        // Error handling
      },
    );
  });
